var $e0321b43bdefb8b3$exports = {};
$e0321b43bdefb8b3$exports = {
  "Clear search": "Obri\u0161i pretragu"
};
export { $e0321b43bdefb8b3$exports as default };